import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Stack, Radio, RadioGroup, Box, Icon, Switch, FormControl, FormLabel } from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import {
  setBaseMap,
  setBaseMapVisibly,
  setMapLayers
} from '../../../redux/actions/map.actions'

export default function LayerControl() {
  const dispatch = useDispatch()
  const isBaseMapListVisibly = useSelector(
    (state) => state.mapStates.isBaseMapListVisibly,
  )

  const baseMap = useSelector((state) => state.mapStates.baseMap)
  const activeMapLayers = useSelector((state) => state.mapStates.activeMapLayers)

  const onBaseMapChange = (value) => {
    dispatch(setBaseMap(value))
  }

  const onSetBaseMapVisibly = () => {
    dispatch(setBaseMapVisibly(false))
  }

  const onLayersChange = (name) => {
    let layers
    if (activeMapLayers.includes(name)) {
      layers = activeMapLayers.filter(l => l !== name)
    } else {
      layers = [...activeMapLayers, name]
    }
    dispatch(setMapLayers(layers))
  }

  if (!isBaseMapListVisibly) {
    return null
  }
  return (
    <Box
      position="absolute"
      zIndex={1199}
      backgroundColor="white"
      padding={2}
      left={'0.5em'}
      bottom="3em"
      borderRadius={5}
    >
      <Icon
        as={MdClose}
        w={4}
        h={4}
        onClick={onSetBaseMapVisibly}
        cursor="pointer"
        color="gray.600"
        position={'absolute'}
        right={2}
      />
      <RadioGroup onChange={onBaseMapChange} value={baseMap} mt={3}>
        <Stack padding={1} spacing={0}>
          <Radio size="sm" name="osm" value="osm" colorScheme="teal">
            OpenStreetMap
          </Radio>
          <Radio
            size="sm"
            name="Esri_LightGray"
            value="Esri_LightGray"
            colorScheme="teal"
          >
            ESRI Light Gray Canvas
          </Radio>
          <Radio
            size="sm"
            name="Esri_DarkGray"
            value="Esri_DarkGray"
            colorScheme="teal"
          >
            ESRI Dark Gray Canvas
          </Radio>
          {/* <Radio */}
          {/*   size="sm" */}
          {/*   name="cartoDark" */}
          {/*   value="cartoDark" */}
          {/*   colorScheme="teal" */}
          {/* > */}
          {/*   CartoDB Dark */}
          {/* </Radio> */}
          {/* <Radio */}
          {/*   size="sm" */}
          {/*   name="cartoPositron" */}
          {/*   value="cartoPositron" */}
          {/*   colorScheme="teal" */}
          {/* > */}
          {/*   CartoDB Positron */}
          {/* </Radio> */}
          <Radio
            size="sm"
            name="Esri_WorldImagery"
            value="Esri_WorldImagery"
            colorScheme="teal"
          >
            Esri WorldImagery
          </Radio>
        </Stack>
      </RadioGroup>
      <FormControl display='flex' alignItems='center' mt="2" >
        <Switch size={"sm"} id='countryBorder' colorScheme="teal" defaultChecked={true} onChange={() => onLayersChange("countryBorder")} />
        <FormLabel htmlFor='countryBorder' ml="2" mb='0' fontSize="sm">
          Country border
        </FormLabel>
      </FormControl>
    </Box>
  )
}
